import React, { useState, useEffect, useContext, useMemo } from "react";
import styled from "styled-components";
import ActionContext from "context/ActionContext";
import _ from "lodash";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const [totalRows, setTotalRows] = useState(0);
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {}, [isRefetched]);

  useEffect(() => {
    getSavings();
  }, [isRefetched, action.parameters?.impact?.targetedenergy]);

  const getSavings = async (route) => {
    setStructureData(action.parameters?.impact?.targetedenergy || []);
  };

  const SubHeaderComponent = () => {
    return (
      <>
        <TableName>Projections</TableName>
      </>
    );
  };

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: <SubHeaderComponent />,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    refreshTable,
  };
}
